// extracted by mini-css-extract-plugin
module.exports = {"voteModal":"VoteModal_voteModal__19gv1","voteModalText":"VoteModal_voteModalText__3_pyA"};